module.exports = __webpack_public_path__ + "main/assets/public/player/playlist-icon.e582b552ae7db57f.svg";